import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './PendenciasIA.css';

function PendenciasIA(props) {
  const [pendencias, setPendencias] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [notificacoesAtivas, setNotificacoesAtivas] = useState(true);
  const [somAtivo, setSomAtivo] = useState(true);
  const navigate = useNavigate();

  // 1) NOVA FUNÇÃO
const manterPendencia = async (lead_id, telefoneCru) => {
  if (!window.confirm('Manter com a IA? Isso vai remover a pendência e desbloquear o número.')) return;
  try {
    const res = await axios.post(
      'https://welaunchyou.com.br/crm-wly/api/openai/pendencias_ia.php',
      { acao: 'manter', lead_id, telefone: (telefoneCru || '').toString().replace(/\D/g, '') },
      { withCredentials: true }
    );

    if (res.data?.success) {
      // remove da listagem local
      setPendencias(prev => prev.filter(p => p.lead_id !== lead_id));
      if (props.atualizarContador) props.atualizarContador();
      alert('Pendência removida e número desbloqueado.');
    } else {
      alert(res.data?.message || 'Erro ao manter (remover pendência/desbloquear).');
    }
  } catch (e) {
    console.error(e);
    alert('Erro ao manter (remover pendência/desbloquear).');
  }
};


  useEffect(() => {
    setNotificacoesAtivas(localStorage.getItem('notificacoes_pendencias') !== 'off');
    setSomAtivo(localStorage.getItem('som_pendencias') !== 'off');
  }, []);

  const carregarPendencias = async () => {
    setCarregando(true);
    const usuario_id = localStorage.getItem('usuario_id');
    try {
      const res = await axios.get('https://welaunchyou.com.br/crm-wly/api/openai/pendencias_ia.php', {
        withCredentials: true,
        params: { usuario_id }
      });

      if (res.data?.success && Array.isArray(res.data.pendencias)) {
        setPendencias(res.data.pendencias);
      } else {
        console.warn('⚠️ Resposta inesperada:', res.data);
        setPendencias([]);
      }
    } catch (error) {
      console.error('Erro ao carregar pendências:', error);
      setPendencias([]);
    } finally {
      setCarregando(false);
    }
  };

  const assumirPendencia = async (lead_id, telefoneCru) => {
    if (!window.confirm('Deseja assumir essa pendência e desativar a IA para este lead?')) return;

    try {
      const res = await axios.post(
        'https://welaunchyou.com.br/crm-wly/api/openai/pendencias_ia.php',
        { lead_id },
        { withCredentials: true }
      );

      if (res.data?.success) {
        // Remove da lista local
        setPendencias(prev => prev.filter(p => p.lead_id !== lead_id));

        // Atualiza contador no pai (se existir)
        if (props.atualizarContador) props.atualizarContador();

        // Redireciona para o painel de mensagens do lead assumido
        const tel = (telefoneCru || '').toString().replace(/\D/g, ''); // garante só dígitos
        navigate(`/wzp/painel-mensagens?telefone=${encodeURIComponent(tel)}&leadId=${lead_id}`);
      } else {
        alert(res.data?.message || 'Erro ao assumir pendência');
      }
    } catch (error) {
      console.error(error);
      alert('Erro ao assumir pendência');
    }
  };

  useEffect(() => {
    carregarPendencias();
  }, []);

  // Helper apenas para exibição (não use no link)
  const formatarTelefoneBR = (t) =>
    (t || '').replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');

  return (
    <div className="p-4 max-w-5xl mx-auto">
      <div className="mb-4 flex items-center gap-6">
        {/* Notificações */}
        <div className="flex items-center gap-2">
          <label className="font-semibold">Notificação de Pendência:</label>
          <label className="switch">
            <input
              type="checkbox"
              checked={notificacoesAtivas}
              onChange={(e) => {
                const novoValor = e.target.checked;
                setNotificacoesAtivas(novoValor);
                localStorage.setItem('notificacoes_pendencias', novoValor ? 'on' : 'off');
                alert(`Notificações ${novoValor ? 'ativadas' : 'desativadas'}.`);
              }}
            />
            <span className="slider round"></span>
          </label>
        </div>

        {/* Som */}
        <div className="flex items-center gap-2">
          <label className="font-semibold">Alerta Sonoro:</label>
          <label className="switch">
            <input
              type="checkbox"
              checked={somAtivo}
              onChange={(e) => {
                const novoValor = e.target.checked;
                setSomAtivo(novoValor);
                localStorage.setItem('som_pendencias', novoValor ? 'on' : 'off');
                alert(`Som ${novoValor ? 'ativado' : 'desativado'}.`);
              }}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      {carregando ? (
        <p>Carregando pendências...</p>
      ) : pendencias.length === 0 ? (
        <p>Nenhuma pendência encontrada.</p>
      ) : (
        <table className="w-full border mt-4">
          <thead>
            <tr className="bg-gray-100">
              <th className="text-left p-2">Lead</th>
              <th className="text-left p-2">Telefone</th>
              <th className="text-left p-2">Data</th>
              <th className="text-left p-2">Motivo</th>
              <th className="text-left p-2">Ação</th>
            </tr>
          </thead>
          <tbody>
            {pendencias.map((p) => (
              <tr key={p.id}>
                <td className="p-2">{p.nome_lead || '---'}</td>
                <td className="p-2">{formatarTelefoneBR(p.telefone)}</td>
                <td className="p-2">
                  {p.data_pendencia
                    ? new Date(p.data_pendencia).toLocaleDateString('pt-BR')
                    : '---'}
                </td>
                <td className="p-2">{p.motivo || '---'}</td>
                <td className="p-2">
  <button
    onClick={() => assumirPendencia(p.lead_id, p.telefone)}
    className="btn-acao btn-assumir"
  >
    Assumir
  </button>

  <button
    onClick={() => manterPendencia(p.lead_id, p.telefone)}
    className="btn-acao btn-manter"
    title="Remover pendência e desbloquear o número (IA segue ativa)"
  >
    Manter
  </button>
</td>

              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default PendenciasIA;
